import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  config: {
    initialColorMode: 'light', 
    useSystemColorMode: false, 
  },
  fonts: {
    heading: "'Diodrum Arabic Medium', sans-serif",
    body: "'Diodrum Arabic Medium', sans-serif",
    arabic: "'Diodrum Arabic Medium', sans-serif",
  },
});


export default theme;